import { ReportSdk } from 'lib-klab-sdks';
import {
    RankingItemDomain,
    PeriodRankingResponseDomain,
} from '../../../domain/models/reports/period-ranking-response.model';
import {
    ActivityHistoryDetailDomain,
    ActivityHistoryResponseDomain,
    ActivityHistoryPaginationDomain,
} from '../../../domain/models/reports/activity-history-response.model';
import { EmployeeSummaryResponseDomain } from '../../../domain/models/reports/employee-summary-response.model';
import { PeriodActivityDomain } from '../../../domain/models/reports/period-activity.model';
import { ActivityBreakdownResponseDomain } from '../../../domain/models/reports/activity-breakdown-response.model';

export function mapSdkEmployeeSummaryResponseToDomain(
    resp: ReportSdk.EmployeeSummaryResponse,
): EmployeeSummaryResponseDomain {
    return {
        totalEmployees: resp?.totalEmployees,
        activeEmployees: resp?.activeEmployees,
        inactiveEmployees: resp?.inactiveEmployees,
        logOutEmployees: resp?.logOutEmployees,
        absentEmployees: resp?.absentEmployees,
        suspendedEmployees: resp?.suspendedEmployees,
    };
}

export function mapSdkPeriodActivityToDomain(
    period?: ReportSdk.PeriodActivity,
): PeriodActivityDomain | undefined {
    if (!period) return undefined;
    return {
        officeSeconds: period?.officeSeconds,
        officePercentage: period?.officePercentage,
        activeSeconds: period?.activeSeconds,
        activePercentage: period?.activePercentage,
        inactiveSeconds: period?.inactiveSeconds,
        inactivePercentage: period?.inactivePercentage,
        productiveSeconds: period?.productiveSeconds,
        productivePercentage: period?.productivePercentage,
        unproductiveSeconds: period?.unproductiveSeconds,
        unproductivePercentage: period?.unproductivePercentage,
        neutralSeconds: period?.neutralSeconds,
        neutralPercentage: period?.neutralPercentage,
    };
}

export function mapSdkActivityBreakdownResponseToDomain(
    resp: ReportSdk.ActivityBreakdownResponse,
): ActivityBreakdownResponseDomain {
    return {
        today: mapSdkPeriodActivityToDomain(resp?.today),
        yesterday: mapSdkPeriodActivityToDomain(resp?.yesterday),
        week: mapSdkPeriodActivityToDomain(resp?.week),
    };
}

export function mapSdkRankingItemToDomain(item: ReportSdk.RankingItem): RankingItemDomain {
    return {
        id: item?.id,
        position: item?.position,
        name: item?.name,
        timeSeconds: item?.timeSeconds,
        percentage: item?.percentage,
    };
}

export function mapSdkPeriodRankingResponseToDomain(
    resp: ReportSdk.PeriodRankingResponse,
): PeriodRankingResponseDomain {
    return {
        today: (resp?.today ?? []).map(mapSdkRankingItemToDomain),
        yesterday: (resp?.yesterday ?? []).map(mapSdkRankingItemToDomain),
        week: (resp?.week ?? []).map(mapSdkRankingItemToDomain),
    };
}

function mapSdkActivityHistoryPaginationToDomain(
    page?: ReportSdk.PaginationResponse,
): ActivityHistoryPaginationDomain {
    return {
        page: page?.page ?? 0,
        size: page?.size ?? 0,
        totalElements: page?.totalElements ?? 0,
        totalPages: page?.totalPages ?? 0,
    };
}

export function mapSdkActivityHistoryDetailToDomain(
    item: ReportSdk.ActivityHistoryDetail,
): ActivityHistoryDetailDomain {
    return {
        name: item?.name,
        location: item?.location,
        department: item?.department,
        contextName: item?.contextName,
        productiveSeconds: item?.productiveSeconds,
        unproductiveSeconds: item?.unproductiveSeconds,
        neutralSeconds: item?.neutralSeconds,
        inactiveSeconds: item?.inactiveSeconds,
    };
}

export function mapSdkActivityHistoryResponseToDomain(
    resp: ReportSdk.ActivityHistoryResponse,
): ActivityHistoryResponseDomain {
    return {
        content: (resp?.content ?? []).map(mapSdkActivityHistoryDetailToDomain),
        page: mapSdkActivityHistoryPaginationToDomain(resp?.page),
    };
}
